var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-progress"},[_c('div',{staticClass:"opple-progress_main"},[_c('div',{staticClass:"opple-progress_bg",style:({width: _vm.progress})})]),_c('p',{staticClass:"opple-progress_text"},[_vm._v(" "+_vm._s(_vm.progress)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }